import { Navigate, Outlet } from "react-router-dom";

import { APP_URLS, INTERNAL_EMAIL_DOMAINS } from "settings";

export const isInternalEmail = (email?: string | null) => {
  const domain = email
    ?.trim()
    .toLowerCase()
    .match(/@([^@]+)$/)?.[1];
  return !!domain && INTERNAL_EMAIL_DOMAINS.includes(domain);
};

/**
 * Route internal  users to requested page, else to Cases
 */
export default function RouteRequireInternalUser({
  email,
}: {
  email?: string | null;
}) {
  if (!isInternalEmail(email)) {
    return <Navigate replace to={APP_URLS.CASE_MANAGEMENT} />;
  }

  return <Outlet />;
}
